module.exports = __webpack_public_path__ + "static/media/apple.955ab9b7.svg";